module.exports = __webpack_public_path__ + "static/2_years_side_by_side-f9858870e123897d2c8f74902ce4373d.png";